import { apiCookieDomain, cookieSecure } from './runtimeConfig';

function checkCookie(name) {
  return document.cookie
    .split('; ')
    .some(c => c.startsWith(`${name}=`));
}

function setCookie(name, value) {
  let now = new Date();
  now.setTime(now.getTime() + 2 * 3600 * 1000);
  const secureAttribute = cookieSecure ? '; Secure' : '';
  document.cookie = `${name}=${value}; expires=${now.toUTCString()}; path=/; SameSite=Lax${secureAttribute}`;
}

function removeCookie(name, query = '') {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; ${query} path=/`;
}

function isUserCookie() {
  return checkCookie(getUserCookieName());
}

function setUserCookie() {
  setCookie(getUserCookieName(), 'true');
}

function removeUserCookie() {
  removeCookie(getUserCookieName());
}

function clearCookie() {
  removeUserCookie();
  removeCsrfCookie();
}

function removeCsrfCookie() {
  if (!apiCookieDomain) {
    removeCookie(getCsrfTokenName());
    removeCookie('XSRF-TOKEN');
    return;
  }

  const variants = [apiCookieDomain, `.${apiCookieDomain}`];

  for (const d of variants) {
    const q = `domain=${d};`;
    removeCookie(getCsrfTokenName(), q);
    removeCookie('XSRF-TOKEN', q); // legacy cleanup
  }
}

function getCsrfTokenName() {
  const env = (process.env.REACT_APP_ENV || '').toLowerCase();
  const appendEnvs = ['dev', 'uat', 'demo'];

  return appendEnvs.includes(env)
    ? `XSRF-TOKEN-${env}`
    : 'XSRF-TOKEN';
}

function getUserCookieName() {
  return `${process.env.REACT_APP_USER_COOKIE}${getEnvSuffix()}`;
}

function getEnvSuffix() {
  const env = process.env.REACT_APP_ENV;
  return !env || env === 'production' ? '' : `_${env}`;
}


export {
  checkCookie,
  removeCookie,
  isUserCookie,
  setUserCookie,
  removeUserCookie,
  clearCookie,
  removeCsrfCookie,
  getCsrfTokenName,
  getUserCookieName,
};
